module.exports = __webpack_public_path__ + "static/media/iconCanvas07.1d266ce2.svg";